import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { SignUp as ClerkSignUp, useAuth as useClerkAuth } from '@clerk/clerk-react';
import { isDevMode } from '../components/auth/DevModeAuth';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Dev mode signup page - doesn't use Clerk hooks
 */
function DevSignupPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/projects', { replace: true });
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="w-full max-w-md text-center">
        <Card className="bg-yellow-500/10 border-yellow-500/20 mb-6">
          <CardContent className="p-4">
            <p className="text-yellow-500">
              <strong>Dev Mode:</strong> Auto-signing in...
            </p>
          </CardContent>
        </Card>
        <p className="text-muted-foreground">
          Redirecting to{' '}
          <Link to="/projects" className="text-primary hover:underline">
            projects
          </Link>
        </p>
      </div>
    </div>
  );
}

/**
 * Production signup page - uses Clerk authentication
 */
function ClerkSignupPage() {
  const { isSignedIn, isLoaded } = useClerkAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      navigate('/projects', { replace: true });
    }
  }, [isLoaded, isSignedIn, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-bold text-center mb-6 text-foreground">Create Account</h1>
        <p className="text-muted-foreground text-center mb-8">
          Sign up to start managing your secrets securely.
        </p>

        <div className="flex justify-center">
          <ClerkSignUp
            appearance={{
              elements: {
                rootBox: 'w-full',
                card: 'shadow-none border border-border bg-card',
                headerTitle: 'hidden',
                headerSubtitle: 'hidden',
                socialButtonsBlockButton: 'border-border hover:bg-accent',
                formButtonPrimary: 'bg-primary hover:bg-primary/90',
                footerActionLink: 'text-primary hover:text-primary/80',
              },
            }}
            routing="hash"
            signInUrl="/login"
            fallbackRedirectUrl="/projects"
          />
        </div>

        <p className="text-sm text-muted-foreground text-center mt-6">
          <Link to="/" className="text-primary hover:underline">
            Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}

export function SignupPage() {
  // Render dev or production version based on mode
  // This prevents Clerk hooks from being called when ClerkProvider isn't mounted
  return isDevMode ? <DevSignupPage /> : <ClerkSignupPage />;
}
